document.addEventListener('DOMContentLoaded', function () {

    async function getCurrentProductVariants(url) {
        const productRes = await fetch((url || window.location.pathname) + '.js');
        const productData = await productRes.json();
        const prodVariants = productData.variants;

        return prodVariants;
    }

    async function getCurrentCartVariants() {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        cartVariants = cartData.items;
        return cartVariants;
    }

    async function compare(productUrl, button) {
        if (!button) {
            return;
        }

        const productVariantsArr = await getCurrentProductVariants(productUrl);
        const cartVariantsArr = await getCurrentCartVariants();

        // Check if the product is available (any variant in stock)
        const anyVariantAvailable = productVariantsArr.some(variant => variant.available);
        
        if (!anyVariantAvailable) {
            button.setAttribute('disabled', 'disabled');
            button.innerHTML = 'Sold Out';
            return;
        }

        //console.log("Cart Array" + ' ' + cartVariantsArr);
        //console.log("Cart Array Length" + ' ' + cartVariantsArr.length);

        if (cartVariantsArr.length === 0 || cartVariantsArr === null) {
            button.removeAttribute('disabled');
            button.innerHTML = 'Add to Cart';
            return;
        }

        if (productVariantsArr.length === 0 || cartVariantsArr.length === 0) {
            //console.log('No Variants Found');
            return;
        }

        let cartVariantMap = new Map(cartVariantsArr.map(cartVariant => [cartVariant.variant_id, cartVariant]));

        productVariantsArr.forEach((productVariant) => {
            let cartVariant = cartVariantMap.get(productVariant.id);
            if (cartVariant) {
                if (productVariant.id === cartVariant.variant_id) {
                    //console.log('Match Found');

                    if (cartVariant.quantity === 2) {

                        button.setAttribute('disabled', 'disabled');
                        button.innerHTML = 'Max Qty Reached (2/2)';

                    } else if (cartVariant.quantity === 1) {

                        button.removeAttribute('disabled');
                        button.innerHTML = 'Add to Cart (1/2)';

                    } else {

                        button.removeAttribute('disabled');
                        button.innerHTML = 'Add to Cart';
                    }

                } else {

                    button.removeAttribute('disabled');
                    button.innerHTML = 'Add to Cart';

                }
            };
        });
    }

    function buttonDisplayHandler() {
        const atcDomestic = document.getElementById('smartButtons');
        const atcInt = document.getElementById('smartButtonsInt');


        fetch('https://ipgeolocation.abstractapi.com/v1/?api_key=51e316b48a0140f896e4da1589259c44')
            .then((response) => response.json())
            .then((data) => {
                if (data.country_code === 'US' || data.country_code === 'GU' || data.country_code === 'MP' || data.country_code === 'WS' || data.country_code === 'VI' || data.country_code === 'PR') {
                    atcDomestic.style.display = 'flex';
                } else {
                    atcInt.style.display = 'flex';
                }
            })
            .catch((error) => console.error('Error fetching IP geolocation:', error));
    }

    function compareFull(e) {
        var compareEl = e.detail !== null ? e.detail.productUrl : null;
        let atcButton = document.getElementById('smartButtonsInt');
        async function runCompareAndButtonDisplay() {
            await compare(compareEl, atcButton);
            buttonDisplayHandler();
        }
        runCompareAndButtonDisplay();
    }

    document.addEventListener('quickview:loaded', function (e) {
        e.stopPropagation();
        compareFull(e);
    });

    document.addEventListener('cart:updated', function (e) {
        compareFull(e);
    });

    document.addEventListener('cart:added', function (e) {
        compareFull(e);
    });

    if (window.location.pathname.includes('/products/')) {
        let atcButton = document.getElementById('smartButtonsInt');
        async function runCompareAndButtonDisplay() {
            await compare(null, atcButton);
            buttonDisplayHandler();
        }

        runCompareAndButtonDisplay();
    }

});